import { ConversationType, Folder, Priority } from '../../../models/communication.types';
import { Paths } from '../../../utils/routerUrls';
import { Prompt } from '../Prompt.component';

export type unreadMessageActionType = 'enterSession' | 'download' | 'sendback';

interface UnreadMessagePromptProps {
  action: unreadMessageActionType;
  unreadConversationType: ConversationType;
  sheetCodeWithTaskGroupName: string;
  onConfirm: (url: string) => void;
}

export const UnreadMessagePrompt: React.FC<UnreadMessagePromptProps> = (props) => {
  const getMainText = (): string => {
    if (props.action === 'download')
      return 'Aby pobrać kolejne RGZ musisz najpierw odczytać wszystkie wiadomości o priorytecie: wysoki.';
    else if (props.action === 'sendback')
      return 'Aby odesłać ocenione RGZ musisz odczytać wszystkie wiadomości o priorytecie: wysoki.';
    else return 'Aby rozpocząć pracę w sesji musisz odczytać wszystkie wiadomości o priorytecie: ważny.';
  };

  const buildURL = (): string => {
    const folder =
      props.unreadConversationType === ConversationType.SpecialCase ? Folder.SpecialCasesToSolve : Folder.Received;
    const sheetCodeWithTaskGroupName = encodeURIComponent(props.sheetCodeWithTaskGroupName);
    const priority = props.action === 'enterSession' ? Priority.Medium : Priority.High;
    const isRead = false;
    return `${Paths.mailbox}?folder=${folder}&session=${sheetCodeWithTaskGroupName}&priority=${priority}&isRead=${isRead}`;
  };

  return (
    <Prompt
      type={'unread message'}
      open
      mainText={getMainText()}
      mainActionButtonText={props.action === 'enterSession' ? 'Odczytaj wiadomości' : 'Przejdź do skrzynki odbiorczej'}
      onConfirm={() => props.onConfirm(buildURL())}
    />
  );
};
